module.exports = __webpack_public_path__ + "img/Group 1865.cd3f0018.svg";